export default () => {
  const formModal = document.querySelector('.ShippingStatusModal__form');
  const errorBlock = document.querySelector('.ShippingStatusModal__border-block');

  formModal.reset();
  errorBlock.classList.remove('has-errors');
};
